import { SxProps, Theme } from "@mui/system"

export const containerModalNFT: SxProps<Theme> = {
  margin: { xs: "16px 4px", sm: "16px 8px" },
}

export const typoChangeNFT: SxProps<Theme> = {
  color: "#72976B",
  textDecoration: "underline",
  cursor: "pointer",
}

export const boxSelectNFT: SxProps<Theme> = {
  padding: "0.75rem",
  gap: "0.5rem",
  borderRadius: "0.5rem",
  border: "2px dashed #72976B",
  cursor: "pointer",
}

export const typoSelectNFT: SxProps<Theme> = {
  fontWeight: 600,
  textAlign: "center",
  color: "#72976B",
  fontSize: { xs: 14, sm: 16 },
}

export const styleGradient = (checked: boolean) => ({
  background: checked ? "linear-gradient(100deg, #FFEDD7 10%, #D898EA 100%)" : "#E0E0E6",
  padding: checked ? "2px" : "1px",
  borderRadius: "8px",
})

export const boxNftItem = (isValid: boolean) => ({
  position: "relative",
  borderRadius: "8px",
  backgroundColor: "#FFFFFF",
  cursor: isValid ? "pointer" : "default",
  opacity: isValid ? 1 : 0.5,
})

export const boxNftSelectedItem = (isError: boolean) => ({
  border: `1px solid ${isError ? "#EB5757" : "#D9D9D9"}`,
  borderRadius: "8px",
  padding: "8px",
  position: "relative",
})

export const boxNftItemImage: SxProps<Theme> = {
  padding: { xs: "12px 15px", sm: "12px 15px" },
  width: "100%",
  height: "100%",
}

export const boxNftItemDetail: SxProps<Theme> = {
  borderRadius: "0 0 6px 6px",
  border: "1px  solid rgba(255, 255, 255, 0.00)",
  backgroundColor: "#E0E0E6",
  padding: "12px 10px",
}

export const boxNftItemDetailTitle: SxProps<Theme> = {
  fontSize: 14,
  fontWeight: 600,
  color: "#212134",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}

export const boxNftItemDetailSubTitle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: 14,
  color: "#666687",
  "& span:": {
    fontWeight: 500,
  },
}

export const boxNftItemDiscount: SxProps<Theme> = {
  position: "absolute",
  top: 2,
  left: 2,
  backgroundColor: "#F7931A",
  color: "white",
  fontSize: 10,
  height: 24,
  borderRadius: "4px",
  "& .MuiChip-label": {
    padding: "2px 10px",
  },
}

export const boxNftItemDetailPromotion: SxProps<Theme> = {
  color: "#484848",
}
export const buttonSubmit: SxProps<Theme> = {
  width: { xs: "100%", sm: "436px" },
  lineHeight: "2rem",
  fontSize: 20,
  fontWeight: 700,
}

export const typoError: SxProps<Theme> = {
  color: "#EB5757",
  fontSize: 13,
  fontStyle: "italic",
}

export const typoNoData: SxProps<Theme> = {
  color: "#0F171F",
  fontSize: { xs: 14, sm: 20 },
  fontWeight: 700,
  textAlign: "center",
}
